import React, { useEffect, useState } from 'react';
import TowerEditor from './TowerEditor';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeBody, changeField, initialize } from '../../modules/tower/towerWriteSlice';

const TowerEditorContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [project, setProject] = useState('');

    const { title, body, tags, user } = useSelector(({ towerWrite }) => ({
        title: towerWrite.title,
        body: towerWrite.body,
        tags: towerWrite.tags,
        user: towerWrite.user,
    }));

    useEffect(() => {
        // 프로젝트 정보를 localStorage에 저장
        setProject(JSON.parse(localStorage.getItem('project')));

        return () => {
            dispatch(initialize());
        };
    }, [dispatch]);

    const onChangeField = (payload) => {
        dispatch(changeField(payload));
    };

    const onChangeBody = payload => {
        dispatch(changeBody(payload));
    }

    const onBackToList = () => {
        // const projectId = project?._id;
        navigate(-1);
        // navigate(`/projects/${projectId}`);
    };

    // 전체 중량 계산하는 기능 구현 예정

    return (
        <TowerEditor
            onChangeField={onChangeField}
            onChangeBody={onChangeBody}
            onBackToList={onBackToList}
            title={title}
            body={body}
            tags={tags}
            project={project}
            use={user}
        />
    );
};

export default TowerEditorContainer;
